<template>
    <div class="main-outfit-container">
        <div
                id="generated-outfit-container"
                class="generated-outfit-container overflowHidden saved-outfit-container"
        >
            <transition name="fade" mode="out-in" :duration="{ enter: 1100, leave: 800 }">
                <div v-if="outfitCurrent.products" class="outfit-items-container" key="1">
                    <outfit-card
                        :outfit="outfitCurrent"
                        :handleProductClk="handleItemClick"
                    />
                </div>
                <div v-else key="2">
                    <loader></loader>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>

    import Mixins from '../../mixins/mixins';
    import {mapGetters} from 'vuex';
    import $ from 'webpack-zepto';
    import Loader from '../common/loader.vue';
    import OutfitCard from '../style-selection/outfit-card.vue';
    import { OUTFIT_TYPES } from '../../config.js';

    export default {
        mixins: [Mixins],
        components: {Loader, OutfitCard},
        computed: {
            ...mapGetters({
                outfitCurrent: 'savedOutfits/savedOutfitCurrent'
            }),
        },
        data(){
            return {
                outfitHeight: 300
            }
        },
        methods: {
            handleItemClick(product) {
                this.$helpers.visitProduct(
                    this.$router,
                    product,
                    {
                        outfitId: this.outfitCurrent.outfit_id,
                        outfitType: OUTFIT_TYPES.SAVED
                    }
                );
            },
        }
    }
</script>

<style lang="scss" scoped>
    .generated-outfit-container {
        width: 100vw;
        padding: 20px 13px;
        min-height: 400px;
    }
</style>
